import React, { useState, useRef, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./Sorting.module.scss";

const Sorting = ({ sortBy, setSortBy, sortOrder, setSortOrder }: { sortBy?: string, setSortBy?: (field: string) => void, sortOrder?: 'asc' | 'desc', setSortOrder?: (order: 'asc' | 'desc') => void }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSort = (field: string, order: 'asc' | 'desc') => {
    if (setSortBy) setSortBy(field);
    if (setSortOrder) setSortOrder(order);
    setOpen(false);
  };

  const isActive = (field: string, order: 'asc' | 'desc') =>
    sortBy === field && sortOrder === order;

  return (
    <div className={styles.sorting} ref={dropdownRef}>
      <button
        className={styles.toggleBtn}
        type="button"
        onClick={() => setOpen(!open)}
      >
        <FormattedMessage id="nav.sorting" defaultMessage="Sorting" />
        <span className={`${styles.arrow} ${open ? styles.arrowUp : ''}`}>&#9662;</span>
      </button>
      {open && (
        <div className={styles.menu}>
          <span
            className={`${styles.menuItem} ${isActive('dateUpdated', 'desc') ? styles.menuItemActive : ''}`}
            onClick={() => handleSort('dateUpdated', 'desc')}
          >
            <FormattedMessage id="nav.latestSort" defaultMessage="Latest" />
          </span>
          <span
            className={`${styles.menuItem} ${isActive('price', 'asc') ? styles.menuItemActive : ''}`}
            onClick={() => handleSort('price', 'asc')}
          >
            <FormattedMessage id="nav.priceSort" defaultMessage="Price" /> &darr;
          </span>
          <span
            className={`${styles.menuItem} ${isActive('price', 'desc') ? styles.menuItemActive : ''}`}
            onClick={() => handleSort('price', 'desc')}
          >
            <FormattedMessage id="nav.priceSort" defaultMessage="Price" /> &uarr;
          </span>
          <span
            className={`${styles.menuItem} ${isActive('rating', 'desc') ? styles.menuItemActive : ''}`}
            onClick={() => handleSort('rating', 'desc')}
          >
            <FormattedMessage id="nav.ratedSort" defaultMessage="Recommended" />
          </span>
        </div>
      )}
    </div>
  );
};

export default Sorting;
